import React, { useContext } from 'react'
import { useState, useEffect, useRef } from 'react';
import DashboardHeader from '../../Components/DashboardHeader/DashboardHeader'
import Stats from '../../Components/Dashboard/Stats/Stats';
import Summary from '../../Components/Dashboard/Summary/Summary';
import { ProjectsTable, ProjectsTableCompleted } from '../../Components/Dashboard/ProjectsTable/ProjectsTable';
import Notification from '../../Components/Dashboard/Notification/Notification';
import { ClientSnapshot } from '../../Components/ClientSnapshot/ClientSnapshot';
import { fetchAssessments, fetchDeployments } from '../../api';
import AuthContext from '../../Context/AuthContext';
import { CircularProgress } from '@mui/material';
import { Link } from 'react-router-dom';
import { CompletedClients } from '../../Components/CompletedClients/CompletedClients';


const DashboardV1 = () => {

  // other hooks 
  const authCtx = useContext(AuthContext);

  //states
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [clientsData, setClientsData] = useState([])
  const [clientsCount, setClientsCount] = useState(0);
  const notificationRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false)
  const [filteredCompletedClients, setFilteredCompletedClients] = useState([])
  const [filteredOngoingClients, setFilteredOngoingClients] = useState([])
  const [completedClientsDate, setCompletedClientsDate] = useState(null);
  const [statsData, setStatsData] = useState({
    clients: 0,
    respondents: 0,
    completions: 0,
    pending: 0,
  });

  useEffect(() => {
    if (filteredCompletedClients.length > 0 && !completedClientsDate) {
      const today = new Date();
      setCompletedClientsDate(today.toISOString());
    }
  }, [filteredCompletedClients, completedClientsDate]);

  // misc variables
  const completedClients = clientsData.filter(client =>
    client.completeAssessments > 0 && client.completeAssessments === client.totalAssessments
  );

  const ongoingClients = clientsData.filter(
    client => !(client.completeAssessments > 0 && client.completeAssessments === client.totalAssessments)
  );

  // functions
  const fetchApi = async () => {
    setIsLoading(true)
    try {
      const clientData = await fetchDeployments(authCtx)
      // console.log("clientData",clientData)
      if (clientData?.length > 0) {
        let clientDatawithAssessments = await Promise.all(clientData.map(async (client) => {
          let assessments = await fetchAssessments(client.id)
          let completeAssessments = assessments.filter(a => {
            if (a.status !== 'complete') return false;
            if (Array.isArray(a.members)) {
              return a.members.every(m => m.status === 'complete');
            }
          return true;
        });
          console.log("completeAssessments", completeAssessments)
          return {
            ...client,
            totalAssessments: assessments?.length > 0 ? assessments.length : 0,
            completeAssessments: completeAssessments.length,
            pendingAssessment: (assessments?.length > 0 ? assessments.length : 0) - completeAssessments.length,
            assessments
          }
        }));

        clientDatawithAssessments.sort((a, b) => new Date(b.started) - new Date(a.started));
        console.log('clientDatawithAssessments', clientDatawithAssessments)

        setClientsData(clientDatawithAssessments);
        setClientsCount(clientDatawithAssessments.length);

        const completed = clientDatawithAssessments.filter(
          client => client.completeAssessments > 0 && client.completeAssessments === client.totalAssessments
        );
        const ongoing = clientDatawithAssessments.filter(
          client => !(client.completeAssessments > 0 && client.completeAssessments === client.totalAssessments)
        );

        setFilteredCompletedClients(completed);
        setFilteredOngoingClients(ongoing);

        const stats = {
          clients: clientDatawithAssessments.length,
          respondents: clientDatawithAssessments.reduce(
            (sum, client) => sum + (client.respondents || 0),
            0
          ),
          completions: clientDatawithAssessments.reduce(
            (sum, client) => sum + (client.completeAssessments || 0),
            0
          ),
          pending: clientDatawithAssessments.reduce(
            (sum, client) => sum + (client.pendingAssessment || 0),
            0
          ),
        };
        setStatsData(stats);
      }


    }
    catch (error) {
      // console.log("error",error)
    }
    finally {
      setIsLoading(false)
    }
  }

  const handleNotificationOpen = () => {
    setIsNotificationOpen(true);
  }

  const handleNotificationClose = () => {
    setIsNotificationOpen(false);
  };

  // useeffects 
  useEffect(() => {
    fetchApi()
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setIsNotificationOpen(false);
      }
    };

    if (isNotificationOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isNotificationOpen]);


  // logs
  // console.log("clientsData", clientsData)
  // console.log("ongoingClients", ongoingClients)

  return (
    <div className='dashboard-platform'>
      <DashboardHeader heading='Dashboard' handleNotificationOpen={handleNotificationOpen} />
      <Notification ref={notificationRef} handleNotificationClose={handleNotificationClose} isNotificationOpen={isNotificationOpen} />
      <div className='dashboard-container'>
        <div className="inner-container">
          <div className='first-row'>
            <Stats data={statsData} />
            <Summary clientsCount={clientsCount} />
          </div>
          {isLoading ? (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
              <CircularProgress size={60} style={{ color: '#245775' }} />
            </div>
          ) : (
            <>
              {filteredOngoingClients.length > 0 && (
                <ClientSnapshot heading={'Ongoing Clients'} data={filteredOngoingClients} />
              )}
              {filteredCompletedClients.length > 0 && (
                <CompletedClients heading={'Completed Clients'} data={filteredCompletedClients} completedDate={completedClientsDate} />
              )}
              {filteredOngoingClients.length === 0 && filteredCompletedClients.length === 0 && (
                <ClientSnapshot heading={'Client Snapshot'} data={[]} />
              )}
            </>
          )}

          {/* <ProjectsTable heading={'Ongoing Clients'} data={clientsData} /> */}
          {/* <ProjectsTableCompleted heading={'Completed Clients'} data={clientsData} /> */}
          {clientsData?.length > 0 && <div className='bottom-anchor'>
            <Link to="/clients" className='all-clients'>See all clients</Link>
          </div>}
        </div>
      </div>
    </div>
  )
}

export default DashboardV1
